<div>
  <!-- <div class="hero">
      <div id="title-container">
        <h1 id="title">TYT MEMBERSHIP BENEFITS</h1>
      </div>
    </div> -->


  <div class="success-container" [ngClass]="benefitsPage ? 'benefits-page': ''">

    <div class="row">
      <div class="image">
        <img src="assets/membership-benefits/podcast_icon.svg" />
      </div>
      <div class="text">
        <h1>Access to exclusive shows, live events, and podcasts</h1>
        <span>Members get full access to exclusive, award-winning shows, live video, and podcasts. More than 15 hours of
          live content per week!</span>
      </div>
    </div>

    <div class="row">
      <div class="image">
        <img src="assets/membership-benefits/eyeglass_icon.svg" />
      </div>
      <div class="text">
        <h1>Support Independent Journalism</h1>
        <span>Each day, we report on stories that corporate media won't cover.</span>
      </div>
    </div>

    <div class="row">
      <div class="image">
        <img src="assets/membership-benefits/people_icon.svg" />
      </div>
      <div class="text">
        <h1>Participate in an energized community</h1>
        <span>Registered members can continue the discussion that began on our shows in our comments and community pages
          at tyt.com.</span>
      </div>
    </div>

    <div class="row">
      <div class="image">
        <img src="assets/membership-benefits/microphone_svg.svg" />
      </div>
      <div class="text">
        <h1>The best hosts of any news outlet</h1>
        <span>Cenk, Ana, John, and many, many more.</span>
      </div>
    </div>

    <div class="row">
      <div class="image">
        <img src="assets/membership-benefits/tyt_shield_logo_icon.svg" />
      </div>
      <div class="text">
        <h1>Shop member-exclusive merchandise</h1>
        <span>You won't find these designs anywhere else. Register your membership and log in to shoptyt.com to get your
          TYT swag!</span>
      </div>
    </div>

    <div class="btn-container">
      <a href="{{joinUrl}}">Join <strong>TYT Plus</strong></a>
    </div>

  </div>
</div>